import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FiPlusCircle, FiBarChart2 } from 'react-icons/fi';
import GameListComponent from '../components/GameListComponent';
import './styles/Home.css';


function HomePage({ user }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* <h1>{t('golfScoreTracker')}</h1> */}

      <div className="action-buttons">
        <button className="create-game-button" onClick={() => navigate('/create-game')}>
          <FiPlusCircle className="button-icon" aria-hidden="true" />
          {t('createGame')}
        </button>
        <button className="view-statistics-button" onClick={() => navigate('/statistics')}>
          <FiBarChart2 className="button-icon" aria-hidden="true" />
          {t('viewStatistics')}
        </button>
      </div>

      <h2>{t('listOfGames')}</h2>

      <GameListComponent showTabs={true} initialTab="inProgress" highlightRecent />
    </div>
  );
}

export default HomePage;
